import * as t from "./actionTypes";
import { listService, restClient } from "client-app-core";
const jsonata = require("jsonata");

const setLookupValues = (lookupType, values) => {
	return {
		type: t.LOOKUP_DATA_RECEIVED,
		payload: {
			lookupType,
			values
		}
	};
};
/*
 * Add list data to state
 * @param lists: an associative array of lists
 */
const listsReceived = (lists) => {
	return {
		type: t.LISTS_RECEIVED,
		payload: {
			lists
		}
	};
};

// Get all Original Lists from DB
export const getAllLists = () => {
	return (dispatch) => {
		listService.getAll((err, response) => {
			if (err) console.log(err);
			if (!response) return;
			dispatch(listsReceived(response));
		});
	};
};

// Stream all original (Lists App) lists from DB
export const streamLists = () => {
	return (dispatch) => {
		listService.streamOriginalLists((err, response) => {
			if (err) console.log(err);
			if (!response) return;
			dispatch(listReceived(response.new_val.id, response.new_val));
		});
	};
};

/*
 * Update list data in state
 * @param listId: id of list to be updated
 * @param list: updated list data
 */
const listReceived = (listId, list) => {
	return {
		type: t.LIST_RECEIVED,
		payload: {
			listId,
			list
		}
	};
};

/*
 * Create a new list
 * @param list: list data
 */
export const createList = (list) => {
	return () => {
		listService.createList(list, (err, response) => {
			if (err) console.log(err);
			if (!response) return;
		});
	};
};

/*
 * Remove list data from state
 * @param listId: id of list to be removed
 */
export const updateList = (listId, list) => {
	return () => {
		listService.updateList(listId, list, (err, response) => {
			if (err) console.log(err);
			if (!response) return;
		});
	};
};

/* Remove list from DB
 * @param listId: id of list to be removed
 */
export const deleteList = (listId) => {
	return () => {
		listService.deleteList(listId, (err, response) => {
			if (err) console.log(err);
			if (!response) return;
		});
	};
};

/* Duplicate
 * @param listId: id of list to be shared
 * @param list: new list data ({name, type})
 */
export const duplicateList = (listId, list) => {
	return () => {
		listService.cloneList(listId, list, (err, response) => {
			if (err) console.log(err);
			if (!response) return;
		});
	};
};

export const getLookupValues = (lookupType) => {
	return (dispatch, getState) => {
		if (getState().globalData?.listLookupData?.[lookupType]) {
			return;
		} else {
			const listLookupTypeData = getState().globalData?.listLookupData?.lookupTypes;
			if (listLookupTypeData[lookupType]) {
				const lookupTypeData = listLookupTypeData[lookupType];
				if (lookupTypeData?.fetchUrl) {
					restClient.exec_get(lookupTypeData.fetchUrl, (err, response) => {
						if (err) {
							console.error(err, "Error fetching lookup values using the fetchUrl");
						} else {
							if (response && Array.isArray(response)) {
								// Get id and name property names, with defaults
								const idProp = lookupTypeData?.idProperty || "id";
								const expression = lookupTypeData?.nameExpression && jsonata(lookupTypeData?.nameExpression);

								// Get name using either nameProperty or nameExpression or default 'name' property.
								const getName = (item) => {
									if (lookupTypeData?.nameProperty) {
										return item[lookupTypeData.nameProperty];
									} else if (expression) {
										return expression.evaluate(item);
									} else {
										return item.name;
									}
								};

								// Map and transform response
								const lookupValues = response.map((item) => ({
									id: item[idProp],
									name: getName(item)
								}));
								dispatch(setLookupValues(lookupTypeData.lookupType, lookupValues));
							}
						}
					});
				}
			}
		}
	};
};

const lookupTypesReceived = (lookupData) => {
	return {
		type: t.LOOKUPTYPES_RECEIVED,
		payload: {
			lookupData
		}
	};
};

export const getListLookupTypes = () => {
	return (dispatch) => {
		listService.getAllListLookupTypes((err, result) => {
			if (err) console.log(err);
			else {
				dispatch(lookupTypesReceived(result));
			}
		});
	};
};
